/* eslint-disable */
import React from "react";
import "contents/assets/scss/page/community.scss";
import ImageDetailI from "contents/assets/img/ImageDetail1.png";
import ImageDetailII from "contents/assets/img/ImageDetail2.png";
import Upload from "../../component/Inc/Upload";
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
const PhotoDetail = () => {
  return (
    <main className="com_container com_community p_photo_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_1">이지 포토</h2>
          <button className="com_btn orange s btn_plus">이지포토 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <div className="sec_input_field">
                  <input type="text" className="input" placeholder="" />
                </div>
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
            </div>
            <div className="photo_container">
              <div className="photo_title">2023년 시상식 장면 이모저모</div>

              <img src={ImageDetailI} alt="image-one" />
              <img src={ImageDetailII} alt="image-two" />
            </div>
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray s wl" />
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button
                  type="button"
                  className="btn_del_file"
                  onClick={() => {}}
                ></button>
                <button
                  type="button"
                  className="btn_down"
                  onClick={() => {}}
                ></button>
              </p>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap">
              <div className="com_btn lightGray s wl">이전</div>
              <div className="com_btn orange s wl">등록</div>
              <div className="com_btn lightGray s wl">다음</div>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">댓글 보기</div>
            <hr className="com_divider" />
            <div className="com_comment_wrap type_board">
              <ul className="comment_list">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
                  (i, idx) => {
                    return (
                      <li className="item" key={idx}>
                        <div className="info">
                          <p className="name">홍길동103</p>
                          <p className="date dot">2025, 05, 20 11 : 30</p>
                          <div className="com_btn_wrap">
                            <button className="btn_edit"></button>
                            <button className="btn_delete"></button>
                          </div>
                        </div>
                        <p className="txt">축하드려요~!</p>
                      </li>
                    );
                  }
                )}
              </ul>
              <div className="comment_input">
                <textarea
                  type="text"
                  className="textarea"
                  placeholder="댓글을 입력해주세요"
                />
                <button className="com_btn gray l">댓글 등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default PhotoDetail;
